module.exports = __webpack_public_path__ + "static/media/check.b61d7e2b.svg";